import { render } from "./iOSDownload.vue?vue&type=template&id=7c07dc5d&scoped=true"
import script from "./iOSDownload.vue?vue&type=script&lang=js"
export * from "./iOSDownload.vue?vue&type=script&lang=js"

import "./iOSDownload.vue?vue&type=style&index=0&id=7c07dc5d&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c07dc5d"]])

export default __exports__